import React from "react";

import { list } from "../../services/api/Poll";

import { DocumentSearchPage } from "../../components/DocumentSearchPage";
import { PollsTable } from "../../components/PollsTable";
import { PollWithDetails } from "../../common/apiTypes";

export class PollsPage extends React.Component {
  public render() {
    return (
      <DocumentSearchPage
        typeName="Poll"
        placeholder="Polly, Organization or User ID"
        load={list}
        renderTable={(polls: PollWithDetails[]) => <PollsTable polls={polls} />}
      />
    );
  }
}
